<template>
  <v-container fluid>
    <template v-if="currentOrganization">
      <v-row v-if="hasMultipleOrgs || parents.length > 1">
        <v-breadcrumbs :items="organizationBreadcrumbs" class="pt-1 pb-1 pl-2">
          <template #divider><v-icon>{{ mdiChevronRight }}</v-icon></template>
          <template #item="{ item }">
            <router-link
              :to="item.to"
              v-if="item.icon"
            >
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </router-link>
            <v-menu v-else-if="item.children.length > 0" offset-y>
              <template #activator="{ on, attrs }">
                <span
                  class="breadcrumb-menu-activator"
                  :class="{ 'primary--text': !item.disabled }"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.text }}
                  <v-icon small>{{ mdiChevronDown }}</v-icon>
                </span>
              </template>
              <v-list dense>
                <v-list-item
                  :to="item.to"
                  :disabled="item.disabled || !item.to"
                  exact
                >
                  <v-list-item-title class="font-weight-bold">{{ item.text }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                  v-for="child in item.children"
                  :key="child.url"
                  :to="{ name: 'organization.dashboard', params: { id: child.id } }"
                >
                  <v-list-item-title>{{ shortenParish(child.name) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-breadcrumbs-item
              v-else
              :to="item.to"
              :disabled="item.disabled"
            >{{ item.text }}</v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-row>
      <router-view></router-view>
    </template>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { FETCH_ORGANIZATIONS, FETCH_STATIC_CONFIGURATION } from '@/store/action-types'
import { shortenParish } from '@/lib/regex-tools'
import { mdiChevronDown, mdiChevronRight, mdiHome } from '@mdi/js'
import { PERM_TYPE_INTERACT_GENERAL } from '@/lib/permission-tools'

export default {
  name: 'organization-wrapper',
  components: {
  },
  data () {
    return {
      mdiChevronDown,
      mdiChevronRight,
      mdiHome,
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters('organization', ['allOrganizations', 'orgtree', 'currentOrganization']),
    ...mapGetters('user', ['hasPermission', 'hasMultipleOrgs', 'isSuperuser']),
    parents () {
      const retval = []
      if (this.currentOrganization) {
        retval.push(this.currentOrganization.url)
        while (this.allOrganizations[retval[0]]?.parent) {
          retval.unshift(this.allOrganizations[retval[0]]?.parent)
        }
      }
      return retval
    },
    organizationBreadcrumbs () {
      return this.parents.map(item => this.allOrganizations[item]).map(organization => {
        return {
          text: shortenParish(organization.name),
          to: this.hasPermission(organization.url, PERM_TYPE_INTERACT_GENERAL)
            ? {
                name: 'organization.dashboard',
                params: { id: organization.id }
              }
            : null,
          disabled: organization.id === this.currentOrganization.id,
          children: (this.orgtree[organization.url] ?? [])
            .map(childUrl => this.allOrganizations[childUrl])
            .filter(child => child && this.hasPermission(child.url, PERM_TYPE_INTERACT_GENERAL)),
        }
      })
    }
  },
  created () {

  },
  async mounted () {
    await this.$nextTick()
    await Promise.allSettled([
      this.$store.dispatch('staticConfiguration/' + FETCH_STATIC_CONFIGURATION),
      this.$store.dispatch('organization/' + FETCH_ORGANIZATIONS),
    ])
  },
  methods: {
    shortenParish,
  },
}
</script>

<style lang="stylus">
.breadcrumb-menu-activator
  display inline-flex
  align-items center
  cursor pointer
  &:hover
    text-decoration underline
</style>
